import { Fragment } from "react";
import { Card, Col } from "reactstrap";
import { P, Ribbon } from "../../../../AbstractElements";
import { Href } from "../../../../Constants/Constants";
const AnimatedRibbonsCard = () => {
  return (
    <Fragment>
      <Col xl="4" md="6">
        <div className="vertical-ribbon-animate">
          <div className="ribbon-vertical-right-wrapper border border-1 vertical-rp-space height-equal">
            <Ribbon className="ribbon ribbon-vertical-right ribbon-secondary ribbon-bottom-arrow"><span>10% OFF</span></Ribbon>
            <P>Ribbon designs use the class of <em className="txt-danger">ribbon-vertical-right &amp; ribbon-bottom-arrow</em> through create top-start ribbon and common class use "ribbon".</P>
          </div>
        </div>
      </Col>
      <Col xl="4" md="6">
        <Card>
          <div className="animated-ribbon ribbon-wrapper smooth-animate border border-1 height-equal alert-light-light">
            <P className="mb-0">Ribbon designs use the class of <em className="txt-danger">animated-ribbon &amp; smooth-animate</em> through create bottom-end ribbon and common class use "ribbon".</P>
            <div className="box">
              <Ribbon className="ribbon"><i className="back" /><i className="front"><span>Upcoming</span></i>
              </Ribbon>
            </div>
            <div className="box-svg"><svg className="ribbon-svg" id="ribbon" width={300} height={60} /></div>
          </div>
        </Card>
      </Col>
      <Col xl="4" md="6">
        <Card>
          <div className="ribbon-wrapper smooth-animate border border-1 height-equal">
            <P>Ribbon design use the class of <em className="txt-danger">smooth-animate</em> through create top-start ribbon and common class use "ribbon".</P>
            <Ribbon className="box">
              <a className="media-image" href={Href}>
                <span className="label label-new">Hot</span>
              </a>
            </Ribbon>
          </div>
        </Card>
      </Col>
    </Fragment>
  );
};

export default AnimatedRibbonsCard;
